export enum Role {
  MASTER = 'master',
  TENANT = 'tenant',
  USER = 'user'
}
